// import useAbilitiesHelper from "@helpers/AbilitiesHelper"

export const MENU_SALES_CONTRACT = (ability) => {
  // const [isUserAllowed] = useAbilitiesHelper(ability);
  return [
    { name: 'Sales Contract', url: '/salescontract', icon: 'flaticon-coins', hasSubMenu: false, exactMenu: true, permissions: ['pur_so_view', 'pur_so_crud'] },
    {
      name: 'Maintenance', url: '/salescontract/maintenance', icon: 'bi-gear', hasSubMenu: true, permissions: ['pur_maint_so_list', 'pur_maint_so_approvers', 'pur_maint_so_settings', 'pur_maint_so_m_approver', 'pur_maint_so_m_followup', 'pur_maint_so_m_supplier'],
      submenu: [
        { name: 'ATW rules', url: '/salescontract/maintenance/atwrules', permissions: ['pur_maint_so_list'], },
        { name: 'Source', url: '/salescontract/maintenance/lists/source', permissions: ['pur_maint_so_list'], },
        { name: 'Mail Settings', url: '/salescontract/maintenance/mailsettings', permissions: ['pur_maint_so_list'], },
        // { name: 'List', url: '/salescontract/maintenance/lists', permissions: ['pur_maint_so_list'], },
        // { name: 'Approvers', url: '/salescontract/maintenance/approvers', permissions: ['pur_maint_so_approvers'], },
        // { name: "Settings", url: '/salescontract/maintenance/settings', permissions: ['pur_maint_so_settings'], },
        // { name: 'Mail - Approvers', url: '/salescontract/maintenance/mailapprovers', permissions: ['pur_maint_so_m_approver'], },
        // { name: "Mail - Follow-Up", url: '/salescontract/maintenance/mailreminder', permissions: ['pur_maint_so_m_followup'], },
        // { name: "Mail - Customer", url: '/salescontract/maintenance/mailcustomer', permissions: ['pur_maint_so_m_supplier'], },
      ]
    },
  ]
}